import * as React from "react";
import { StatusCard } from "@/components/dashboard/StatusCard";
import { EmptyState } from "@/components/dashboard/EmptyState";

/**
 * `GET /diagnostics` reports real, structured capability-enablement data
 * (name/description/version/enabled/state) that closely resembles
 * feature flags - but it is mounted at an unversioned root path with no
 * `/api/v1` alias (unlike `/health`, `/version`, `/build-info`), so it
 * cannot be reached through the shared, config-driven `apiClient`
 * without a special-case absolute-URL bypass this codebase has
 * consistently avoided. Reported honestly as unavailable rather than
 * worked around. See `CONFIGURATION_GUIDE.md` for the full explanation.
 */
export function FeatureFlagsSection(): React.JSX.Element {
  return (
    <StatusCard title="Feature Flags">
      <EmptyState message="Feature flags are not exposed through the versioned API this frontend consumes." />
    </StatusCard>
  );
}
